/* eslint-disable react/require-default-props */
import React from "react";
import { Box, CircularProgress, Avatar, Badge } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

interface CustomAvatarProps {
  imageUrl: string | undefined | null;
  onClick: any;
  sx?: React.CSSProperties;
  id?: string;
  handleLoad?: any;
  avatarClass?: any;
  circularProgressOverImage?: any;
  isUploading?: boolean;
  name: string;
}

const AddImageAvatar: React.FC<CustomAvatarProps> = ({
  imageUrl,
  onClick,
  sx,
  id,
  handleLoad,
  avatarClass,
  circularProgressOverImage,
  isUploading = false,
  name,
}) => {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      badgeContent={<PhotoCameraIcon />}
      onClick={onClick}
      sx={{ position: "relative" }}
    >
      {isUploading && (
        <Box className={circularProgressOverImage}>
          <CircularProgress size={20} />
        </Box>
      )}
      <Avatar
        className={avatarClass}
        onLoad={handleLoad}
        src={imageUrl || ""}
        style={{
          filter: isUploading ? "blur(5px)" : "none",
        }}
        // sx={sx}
        sx={{
          ...sx,
          bgcolor: "#999",
          width: 40,
          height: 40,
          fontSize: 16,
          flexShrink: "0",
          fontWeight: "bold",
          color: "#fff",
        }}
        id={id}
      >
        {name[0]}
        {name[1]}
      </Avatar>
    </Badge>
  );
};
export default AddImageAvatar;
